import { useCallback } from 'react';

import {
  CHANGE_EMPLOYEES_KEY,
  DELETE_TASKS_KEY,
  FINISH_TASKS_KEY,
} from '@app/pages/TasksList/constants/dropdownKeys';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';
import { getMassActionMenuItem } from '@app/utils/getMassActionMenuItem';

import type { MenuProps } from 'antd';

export const TableMassActionItems = ({
  selectionCount,
  openDeleteTasksModal,
  openChangeEmployeeModal,
  openFinishTaskModal,
  rightToEditTask,
  rightToDeleteTask,
}: NTasksList.TableMassActionItemsProps) => {
  const handleEmployeeChangeClick = useCallback(() => {
    if (selectionCount > 0) {
      openChangeEmployeeModal();
    }
  }, [openChangeEmployeeModal, selectionCount]);

  const handleFinishTasksClick = useCallback(() => {
    if (selectionCount > 0) {
      openFinishTaskModal();
    }
  }, [openFinishTaskModal, selectionCount]);

  const handleDeleteModalOpenClick = useCallback(() => {
    if (selectionCount > 0) {
      openDeleteTasksModal('list');
    }
  }, [openDeleteTasksModal, selectionCount]);

  const items: MenuProps['items'] = [
    ...(rightToEditTask
      ? [
          getMassActionMenuItem({
            key: CHANGE_EMPLOYEES_KEY,
            label: 'Сменить ответственного',
            onClick: handleEmployeeChangeClick,
            disabled: selectionCount === 0,
          }),
          getMassActionMenuItem({
            key: FINISH_TASKS_KEY,
            label: 'Завершить',
            onClick: handleFinishTasksClick,
            disabled: selectionCount === 0,
          }),
        ]
      : []),
    ...(rightToDeleteTask
      ? [
          getMassActionMenuItem({
            key: DELETE_TASKS_KEY,
            label: 'Удалить',
            onClick: handleDeleteModalOpenClick,
            disabled: selectionCount === 0,
          }),
        ]
      : []),
  ];

  return items;
};
